export const backendURL = process.env.VUE_APP_BACKEND_URL;
